import { WORK_ORDERS_URL } from '~/app_constants';
import { get } from 'lodash-es';
import { mapInertiaProps } from '~/utils/inertia';
import { applyTemplate } from '~/utils/url_template';

export default {
  data: () => ({
    processingJob: false,
  }),
  computed: {
    ...mapInertiaProps(['organization']),
    workOrderId() {
      return get(this.work_order, 'id', get(this.workOrder, 'id'));
    },
  },
  methods: {
    getJobUrl(jobId, action = '') {
      const baseUrl = applyTemplate(`${WORK_ORDERS_URL}/jobs/:jobId`, {
        jobId,
        woId: this.workOrderId,
        organizationId: this.organization.id,
      });

      return `${baseUrl}${action}`;
    },
    getJobSchedulesUrl(scheduleId, action = '') {
      const baseUrl = applyTemplate(`${WORK_ORDERS_URL}/job_schedules/:scheduleId`, {
        organizationId: this.organization.id,
        woId: this.workOrderId,
        scheduleId,
      });

      return `${baseUrl}${action}`;
    },
    onSuccess() {
      this.processingJob = false;
    },
    async onDeleteJob(payload, shouldConfirm = true) {
      if (!shouldConfirm || confirm('Are you sure you want to delete this job?')) {
        this.processingJob = true;
        const { job, isAllSelected } = payload;
        const jobUrl = this.getJobUrl(job.id);
        const jobSchedulesUrl = this.getJobSchedulesUrl((job.schedule || {}).id);

        await this.$inertia.delete(
          isAllSelected ? jobSchedulesUrl : jobUrl,
          {},
          { preserveScroll: true, onSuccess: this.onSuccess },
        );

        return true;
      }
    },
    async onReopenJob(job) {
      this.processingJob = true;
      await this.$inertia.patch(
        this.getJobUrl(job.id, '/reopen'),
        {},
        { preserveScroll: true, onSuccess: this.onSuccess },
      );

      return true;
    },
    async onCompleteJob(job) {
      this.processingJob = true;
      await this.$inertia.patch(
        this.getJobUrl(job.id, '/complete'),
        {},
        { preserveScroll: true, onSuccess: this.onSuccess },
      );

      return true;
    },
  },
};
